import { render, staticRenderFns } from "./clients-products-master-list.vue?vue&type=template&id=61ccc586&"
import script from "./clients-products-master-list.vue?vue&type=script&lang=js&"
export * from "./clients-products-master-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports